import { otherApi } from '@/api/otherApi'

// 默认公司信息
const defaultCompanyInfo = {
    phone: '400-123-4567',
    email: 'contact@example.com',
    address: '浙江省杭州市',
    name: '公司名称',
    description: '公司简介'
}

// 获取公司信息
async function getCompanyInfo() {
    try {
        // 先从缓存中获取
        const cachedInfo = sessionStorage.getItem('companyInfo')
        if (cachedInfo) {
            const parsedInfo = JSON.parse(cachedInfo)[0]
            return parsedInfo || defaultCompanyInfo
        }

        // 如果缓存中没有，则请求接口
        const res = await otherApi.getCompanyInfo()
        if (res.code === 200 && res.data && res.data.length > 0) {
            // 保存到缓存
            sessionStorage.setItem('companyInfo', JSON.stringify(res.data))
            return res.data[0]
        }
        return defaultCompanyInfo
    } catch (error) {
        console.error('获取公司信息失败:', error)
        return defaultCompanyInfo
    }
}

export { getCompanyInfo }